function PolicyModel(params) {
    if (!params) params = {};
    var model = {};
    
    model.EmployerId = params.EmployerId || params.PolicyId;
    model.PolicyNumber = params.PolicyNumber || 'N/A';
    model.BusinessUnit = params.Scheme;
    model.Scheme = params.Scheme;
    model.CompanyName = params.CompanyName || params.EmployerName || 'N/A';
    model.EmployerName = params.CompanyName || params.EmployerName || 'N/A';
    model.StatusCode = params.StatusCode;
    model.id = model.EmployerId;
    model.text = model.PolicyNumber + ' - ' + model.CompanyName;

    return model;
}